import React, { useMemo } from 'react'
import ShareWidget from 'components/ShareWidget'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { JobShare_Job$key } from '__generated__/JobShare_Job.graphql'
import { getBaseURL } from 'services/window'

interface IJobShareProps {
  jobFragmentRef: JobShare_Job$key
}

export default function JobShare({ jobFragmentRef }: IJobShareProps) {
  // TODO: possibly refactor this. the `referralFromSelf` field can create a record
  // maybe there should be a shareJob mutation instead

  const job = useFragment(graphql`
    fragment JobShare_Job on Job {
      slug
      firm {
        slug
      }
      referralFromSelf {
        token
      }
    }
  `, jobFragmentRef)

  const { link, referral } = useMemo(() => {
    if (job?.referralFromSelf?.token) {
      return {
        link: `${getBaseURL()}/job/${job.referralFromSelf.token}`,
        referral: true,
      }
    }

    if (job?.slug) {
      return {
        link: `${getBaseURL()}/${job.firm?.slug || 'job'}/${job.slug}`,
        referral: false,
      }
    }

    return {
      link: null,
      referral: false,
    }
  }, [job])

  if (!job || !link) return null

  return (
    <ShareWidget
      referral={referral}
      url={link}
    />
  )
}
